import i18n from '@/i18n'

// Changed to a function that returns the navigation array
// This way it can be re-evaluated when the language changes
export default function getNav() {
  return [
    {
      component: 'CNavItem',
      name: i18n.global.t('nav.dashboard'),
      to: '/dashboard',
      icon: 'cil-applications',
    },
    {
      component: 'CNavItem',
      name: i18n.global.t('nav.users'),
      to: '/users',
      icon: 'cil-people',
    },
    {
      component: 'CNavItem',
      name: i18n.global.t('nav.support'),
      to: '/support',
      icon: 'cil-chat-bubble',
    },
    {
      component: 'CNavItem',
      name: i18n.global.t('nav.roles'),
      to: '/roles',
      icon: 'cil-lock-locked',
    },
    {
      component: 'CNavItem',
      name: i18n.global.t('nav.networks'),
      to: '/networks',
      icon: 'cil-object-ungroup',
    },
    {
      component: 'CNavItem',
      name: i18n.global.t('nav.uploadLimit'),
      to: '/upload',
      icon: 'cil-folder-open',
    },
    {
      component: 'CNavItem',
      name: i18n.global.t('nav.logs'),
      to: '/logs',
      icon: 'cil-fingerprint',
    },
    {
      component: 'CNavItem',
      name: i18n.global.t('nav.ipPolicy'),
      to: '/ip_policy',
      icon: 'cib-gnu-privacy-guard',
    },
    {
      component: 'CNavItem',
      name: i18n.global.t('nav.configs'),
      to: '/configs',
      icon: 'cil-ethernet',
    },
    {
      component: 'CNavItem',
      name: i18n.global.t('nav.otpList'),
      to: '/otp-list',
      icon: 'cil-lock-locked',
    },
    {
      component: 'CNavItem',
      name: i18n.global.t('nav.bots'),
      to: '/bots',
      icon: 'cib-probot',
    },
    {
      component: 'CNavItem',
      name: i18n.global.t('nav.aiChatBot'),
      to: '/ai-bots',
      icon: 'cib-hipchat',
    },
    {
      component: 'CNavItem',
      name: i18n.global.t('nav.versioning'),
      to: '/versioning',
      icon: 'cil-cloud-upload',
    },
    {
      component: 'CNavItem',
      name: i18n.global.t('nav.whitelistContacts'),
      to: '/whitelist',
      icon: 'cil-shield-alt',
    },
    {
      component: 'CNavItem',
      name: i18n.global.t('nav.uploadUsers'),
      to: '/upload-users',
      icon: 'cil-address-book',
    },
    {
      component: 'CNavItem',
      name: i18n.global.t('nav.export'),
      to: '/export',
      icon: 'cil-excerpt',
    },
        {
      component: 'CNavItem',
      name: i18n.global.t('nav.reports'),
      to: '/reports',
      icon: 'cil-ban',
    },
    {
      component: 'CNavItem',
      name: i18n.global.t('nav.posts'),
      to: '/posts',
      icon: 'cil-image',
    },
    {
      component: 'CNavItem',
      name: i18n.global.t('nav.roomPositions'),
      to: '/room-positions',
      icon: 'cil-people',
    },
    {
      component: 'CNavItem',
      name: i18n.global.t('nav.rateLimit'),
      to: '/rate-limit',
      icon: 'cil-speedometer',
    },
    {
      component: 'CNavItem',
      name: i18n.global.t('nav.license'),
      to: '/license',
      icon: 'cil-shield-alt',
    },
  ]
}
